import { RequestTransformers } from '../types/transformers';
import { transformRequestBody } from './transformers/request';
import { TransformerSet } from './TransformerSet';

export const REQUEST_TRANSFORMER_SET_MAP: Record<
  TransformerSet,
  RequestTransformers
> = {
  [TransformerSet.Default]: [transformRequestBody],
  [TransformerSet.PreserveKeys]: [transformRequestBody],
};
